import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CheckPolicyDirective } from '../directives/check-policy.directive';
import { OnRenderedDirective } from "../directives/on-rendered.directive";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatTableModule } from "@angular/material/table";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatSortModule } from "@angular/material/sort";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatDialogModule } from "@angular/material/dialog";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatSelectModule } from "@angular/material/select";
import { MatRadioModule } from "@angular/material/radio";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatOptionModule } from "@angular/material/core";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { CheckPolicyAnyDirective } from "../directives/check-policy-any.directive";
import { CheckPolicyElseDirective } from "../directives/check-policy-else.directive";
import { CheckPolicyAnyElseDirective } from "../directives/check-policy-any-else.directive";
import { MatTooltipModule } from "@angular/material/tooltip";
import { PdfViewerComponent } from "./components/pdf-viewer/pdf-viewer.component";
import { PdfPageViewerComponent } from "./components/pdf-page-viewer/pdf-page-viewer.component";
import { MatCardModule } from "@angular/material/card";
import { MatChipsModule } from "@angular/material/chips";
import { MatTabsModule } from "@angular/material/tabs";
import { LoadingComponent } from './components/loading/loading.component';
import { DataSourceFilterInputComponent } from './components/data-source-filter-input/data-source-filter-input.component';
import { FileSizePipe } from '../pipes/file-size.pipe';
import { CreateTicketModalComponent } from "../features/tickets/components/create-ticket-modal/create-ticket-modal.component";
import { PasswordConfirmationModalComponent } from './components/password-confirmation-modal/password-confirmation-modal.component';
import { TicketRepositoryApi } from "../features/tickets/repository/TicketRepositoryApi";
import { OperatorRepositoryApi } from "../features/tickets/repository/OperatorRepositoryApi";
import { DocProcessorComponent } from './components/doc-processor/doc-processor.component';
import { DocumentEditorContainerModule, RibbonService, ToolbarService } from '@syncfusion/ej2-angular-documenteditor';
import { DecimalNumberDirective } from '../directives/decimal-number.directive';
import { WorkflowHelpPanelComponent } from './components/workflow-help-panel/workflow-help-panel.component';
import { StripeElementsComponent } from './components/stripe-elements/stripe-elements.component';
import { StripeElementsService } from './services/stripe/stripe-elements.service';
import { AiAssistantComponent } from './components/ai-assistant/ai-assistant.component';
import { TwoFactorCodeModalComponent } from './components/two-factor-code-modal/two-factor-code-modal.component';
import { NoDataCardComponent } from './components/no-data-card/no-data-card.component';
import { LegalPopupsComponent } from './components/legal-popups/legal-popups.component';
import { ModalHeaderComponent } from './components/modal-header/modal-header.component';


@NgModule({
  declarations: [
    CheckPolicyDirective,
    CheckPolicyElseDirective,
    CheckPolicyAnyDirective,
    CheckPolicyAnyElseDirective,
    OnRenderedDirective,
    DecimalNumberDirective,
    PdfViewerComponent,
    PdfPageViewerComponent,
    LoadingComponent,
    DataSourceFilterInputComponent,
    CreateTicketModalComponent,
    FileSizePipe,
    PasswordConfirmationModalComponent,
    TwoFactorCodeModalComponent,
    DocProcessorComponent,
    WorkflowHelpPanelComponent,
    StripeElementsComponent,
    AiAssistantComponent,
    NoDataCardComponent,
    LegalPopupsComponent
  ],
  imports: [
    ModalHeaderComponent,
    CommonModule,
    MatInputModule,
    MatListModule,
    MatIconModule,
    MatButtonModule,
    MatFormFieldModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    FormsModule,
    ReactiveFormsModule,
    MatSnackBarModule,
    MatDialogModule,
    MatCheckboxModule,
    MatSelectModule,
    MatRadioModule,
    MatProgressSpinnerModule,
    MatSlideToggleModule,
    MatToolbarModule,
    MatOptionModule,
    MatExpansionModule,
    MatAutocompleteModule,
    MatDatepickerModule,
    MatTooltipModule,
    MatCardModule,
    MatChipsModule,
    MatTabsModule,
    DocumentEditorContainerModule
  ],
  exports: [
    ModalHeaderComponent,
    CheckPolicyDirective,
    CheckPolicyElseDirective,
    CheckPolicyAnyDirective,
    CheckPolicyAnyElseDirective,
    DecimalNumberDirective,
    OnRenderedDirective,
    MatInputModule,
    MatListModule,
    MatIconModule,
    MatButtonModule,
    MatFormFieldModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    FormsModule,
    ReactiveFormsModule,
    MatSnackBarModule,
    MatDialogModule,
    MatCheckboxModule,
    MatSelectModule,
    MatRadioModule,
    MatProgressSpinnerModule,
    MatSlideToggleModule,
    MatToolbarModule,
    MatOptionModule,
    MatExpansionModule,
    MatAutocompleteModule,
    MatDatepickerModule,
    MatTooltipModule,
    PdfViewerComponent,
    PdfPageViewerComponent,
    MatCardModule,
    MatChipsModule,
    MatTabsModule,
    LoadingComponent,
    DataSourceFilterInputComponent,
    FileSizePipe,
    DocProcessorComponent,
    WorkflowHelpPanelComponent,
    StripeElementsComponent,
    AiAssistantComponent,
    NoDataCardComponent,
    LegalPopupsComponent
  ],
  providers: [
    { provide: 'TicketRepositoryInterface', useClass: TicketRepositoryApi },
    { provide: 'OperatorRepositoryInterface', useClass: OperatorRepositoryApi },
    ToolbarService,
    RibbonService,
    StripeElementsService
  ]
})
export class SharedModule {}
